(function () {
  const wishlistButtonSelector = '.nm-wishlist-item-add-to-cart-button';
  const cartState = new Map();
  let cartStateReady = false;

  function getCartUrl() {
    const root = window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : '/';

    return `${root}cart.js`;
  }

  async function fetchCart() {
    const response = await fetch(getCartUrl(), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    });

    if (!response.ok) {
      throw new Error('Unable to retrieve the cart');
    }

    return response.json();
  }

  function rememberCart(cart) {
    cartState.clear();

    cart.items.forEach(function (item) {
      cartState.set(String(item.variant_id), item.quantity);
    });

    cartStateReady = true;
  }

  function getVariantId(button) {
    const card = button.closest('.nm-wishlist-item-card');
    const productLink = card && card.querySelector('.nm-wishlist-item-name[href]');

    if (!productLink) return null;

    return new URL(productLink.href, window.location.origin).searchParams.get('variant');
  }

  async function waitForWishlistItem(variantId, previousQuantity) {
    for (let attempt = 0; attempt < 20; attempt += 1) {
      await new Promise(function (resolve) {
        window.setTimeout(resolve, 300);
      });

      const cart = await fetchCart();
      const item = cart.items.find(function (cartItem) {
        return String(cartItem.variant_id) === variantId;
      });

      if (item && item.quantity > previousQuantity) {
        rememberCart(cart);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { scrollToTop: false }
        }));
        return;
      }
    }
  }

  document.addEventListener('click', function (event) {
    const button = event.target instanceof Element
      ? event.target.closest(wishlistButtonSelector)
      : null;

    if (!button) return;

    const variantId = getVariantId(button);

    if (!variantId) return;

    const previousQuantity = cartStateReady ? (cartState.get(variantId) || 0) : 0;

    waitForWishlistItem(variantId, previousQuantity).catch(function () {
    });
  });

  document.addEventListener('cart:rerendered', function () {
    fetchCart().then(rememberCart).catch(function () {});
  }, true);

  document.documentElement.addEventListener('product:added', function () {
    window.setTimeout(function () {
      fetchCart().then(rememberCart).catch(function () {});
    }, 300);
  });

  fetchCart().then(rememberCart).catch(function () {});
})();
